import React, { useState, useEffect, useRef } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
import Header from "../../../../Components/Header/Header";
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Export from "../../../../assets/images/export.svg";
import View from "../../../../assets/images/view.svg";
import {Button, ProgressBar} from 'react-bootstrap';

import Cargoplane from "../../../../assets/images/plane.svg";
import Cuser from "../../../../assets/images/cuser.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import { Link } from 'react-router-dom';
import ActivityComments from '../../../../Components/common/ActivityComments';
import ImageUpload from '../../../../Components/common/ImageUpload';
import { GETULDDETAILS, MVTHDETAILS } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios';
import Accordion from 'react-bootstrap/Accordion';
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';

const OrdersViewDetails = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const Uldid = queryParameters.get("id");
    const detailsType = queryParameters.get("type");
    const backTab = queryParameters.get("tab");

    let storedData = localStorage.getItem('OVDetails');

    if (storedData) {
        storedData = JSON.parse(storedData)
    }
    const [operationDate, setOperationDate] = useState('');
    const [operationTime, setOperationTime] = useState('');

    const [gridData, setGridData] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const gridRef = useRef(null);

    useEffect(() => {
        const detailsData = JSON.parse(localStorage.getItem('OVDetails'))
        console.log("🚀 ~ useEffect ~ detailsData:", detailsData)
        const operationDateTime = storedData.Form.operation_date;
        if (operationDateTime) {
            const [opDate, opTime] = operationDateTime.split(' ');
            setOperationDate(opDate);
            setOperationTime(opTime);
        }
        setSelectedRowData(detailsData)
        setGridData(storedData.ULD.awbs)
    }, [])

    // const history = useHistory();
    // const location = useLocation();

    // if (Uldid){
    //     setUldNumber(Uldid);
    //     queryParameters.delete('uld_number');
    //     history.push({
    //         pathname: location.pathname,
    //       });
    //     window.location.replace('/ULDControl/MovementHistory')
    // }
    const [uldNumber, setUldNumber] = useState(Uldid);



    useEffect(() => {
        if (gridRef.current) {
            if (gridData) {
                // const localData = gridData[activeTab].map(item => ({

                //     id: item.id,
                //     STN: item.station_code,
                //     Taddrs: item.station_addresses.length,
                //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
                // }));
                // console.log("🚀 ~ localData ~ localData:", localData)
                const source = {
                    datatype: 'json',
                    id: '',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'awb_id', type: 'string' },
                        { name: 'airway_bill', type: 'string' },
                        { name: 'pick_status', type: 'string' },
                        { name: 'pieces', type: 'string' },
                        { name: 'rfc', type: 'string' },
                        { name: 'man', type: 'string' },
                        { name: 'msca', type: 'string' },
                        { name: 'package', type: 'string' },
                        { name: 'uld_number', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'volume', type: 'string' },
                        { name: 'lm', type: 'string' },
                        { name: 'nature_of_goods', type: 'string' },
                    ],
                    localdata: gridData,
                };

                const dataAdapter = new window.$.jqx.dataAdapter(source);
                // console.log('localdata', source.localdata)
                const columns = [
                    { text: 'Airway Bill', datafield: 'airway_bill', width: '8%' },
                    {
                        text: 'Pickup Status', datafield: 'pick_status', width: '11%',
                        cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                            if (value && Array.isArray(value)) {
                                // Generate multiple divs for each item in the array
                                const content = value
                                    .map((item) =>
                                        `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                    ).join(''); // Combine all divs into a single string

                                return `<div class="stats_view">${content}</div>`;
                            }
                            // Fallback if value is not an array or empty
                            return defaulthtml;
                        }
                    },
                    { text: 'Pcs', datafield: 'pieces', width: '7%' },
                    { text: 'RCF', datafield: 'rfc', width: '7%' },
                    { text: 'MAN', datafield: 'man', width: '7%' },
                    { text: 'MSCA', datafield: 'msca', width: '7%' },
                    { text: 'Package', datafield: 'package', width: '8%' },
                    { text: 'ULD No.', datafield: 'uld_number', width: '10%' },
                    { text: 'Weight', datafield: 'weight', width: '8%' },
                    { text: 'Volume', datafield: 'volume', width: '8%' },
                    { text: 'LM', datafield: 'lm', width: '8%' },
                    { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '8%' },

                ];

                const gridOptions = {
                    width: '100%',
                    source: dataAdapter,
                    columns: columns,
                    autoheight: true,
                    sortable: true,
                    altrows: false,
                    enabletooltips: true,
                    editable: false,
                    // selectionmode: 'checkbox',
                    pageable: true,
                    pageSize: 10,
                    pagerButtonsCount: 5,
                    pagerMode: 'advanced',
                    filterable: true,
                    filterrowheight: 45,
                    showfilterrow: true,
                    rowsheight: 42,
                    columnsheight: 45,

                };

                window.$(gridRef.current).jqxGrid(gridOptions);
                window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

                window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                    window.$(row).on('mouseover', () => {
                        window.$(row).addClass('row-hover');
                    });
                    window.$(row).on('mouseout', () => {
                        window.$(row).removeClass('row-hover');
                    });
                });
                //   window.$(gridRef.current).off('cellclick');
                //   window.$(gridRef.current).on('cellclick', (event) => {
                //     const args = event.args.row.bounddata;
                //     // if (event.args.columnindex > 0) {
                //     // if (gridSelect) {
                //     //     gridSelect.forEach(item => {
                //     //         const selectedRowBoundIndex = item.boundindex;
                //     //         window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                //     //     });
                //     // }
                //     loadHistory(args.uld_number);
                //     // }
                //   });

            } else {
                const columns = [
                    { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
                    { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
                ];
            }
        }
    }, [gridData, selectedRowData]);

    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // end
    // const loadDetails = async (uldNumber) => {
    //     try {
    //         const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
    //             .then(function (res) {
    //                 const innerData = res.data.response_data;
    //                 console.log("🚀 ~ .then ~ innerData:654", innerData)
    //                 setSelectedRowData(innerData);

    //             });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // }


    return (
        <>
        {console.log('selectedRowData',storedData)}
            <div className="">
                <Header logo_url='/TruckMonitor' />
                <div className="schedule">
                    <LeftMenu />
                    <div className='main-panel'>
                        <Link to={'/TruckMonitor'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        <div className='maindiv'>
                            <div className='SecondDiv mt-3'>
                                {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
                                <div className='girddtals_header'>
                                    <h3>
                                        {storedData.ULD.order_number} &nbsp;
                                        <span className='position-relative'>
                                            {
                                                storedData.ULD?.pick_status && Array.isArray(storedData.ULD?.pick_status) ?
                                                    storedData.ULD?.pick_status.map((item) =>
                                                        <>
                                                            {/* <div class=""> */}
                                                            <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                                                            {/* </div> */}
                                                        </>
                                                    )
                                                    : ''
                                            }
                                        </span>
                                    </h3>
                                    <div className='d-flex actbtn'>

                                        <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                        {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                                    </div>

                                </div>
                                <div className='d-flex justify-content-between my-3'>
                                    <div className='order_view'>
                                        <h3>{storedData.ULD.loading_station}</h3>
                                        {/* <span>{storedData.ULD.loading_name}</span> */}
                                        <span>
                                            {storedData.ULD.loading_name && storedData.ULD.loading_name.length > 20
                                                ? `${storedData.ULD.loading_name.slice(0, 20)}...`
                                                : storedData.ULD.loading_name}
                                        </span>
                                        <div className='mt-3'>
                                            <p>Scheduled - <b>{storedData.ULD.loading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                            <p>Actual - <b>{storedData.ULD.loading_date_actual} <span></span></b> {/*CEST*/}</p>
                                        </div>
                                    </div>
                                    <div className='order_middle'>
                                        <p><img src={Cargotruck} /></p>
                                        <span>{storedData.ULD.truck_number}</span>
                                    </div>
                                    <div className='order_view'>
                                        <h3>{storedData.ULD.unloading_station}</h3>
                                        {/* <span>{storedData.ULD.unloading_name}</span> */}
                                        <span>
                                            {storedData.ULD.unloading_name && storedData.ULD.unloading_name.length > 20
                                                ? `${storedData.ULD.unloading_name.slice(0, 20)}...`
                                                : storedData.ULD.unloading_name}
                                        </span>
                                        <div className='mt-3'>
                                            <p>Scheduled - <b>{storedData.ULD.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                            <p>ETA - <b>{storedData.ULD.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <ProgressBar animated now={50} style={{ height: "5px" }} />
                                </div>
                                <div className='movment_history'>
                                    <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                                </div>
                                <div className='movment_list'>
                                    <ul>
                                        {storedData.ULD && storedData.ULD?.status_updates.map((history, index) => (
                                            <li>
                                                <span className='movem w-auto'>{history.status}</span>
                                                <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                                {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <ImageUpload
                                    ref={imageUploadRef}
                                    attachable_type={"uld"}
                                    attachable_id={storedData.ULD.uld_number}
                                    attachments={storedData.ULD.attachments}
                                // onDeleteSuccess={() => loadDetails(storedData.ULD.uld_number)}
                                />
                                <ActivityComments
                                    commentable_type={"uld"}
                                    commentable_id={storedData.ULD.uld_number}
                                    allactivities={storedData.ULD.activities}
                                // onReloadDetails={loadDetails}
                                />
                            </div>
                            <div className='trashdonload mt-3'>
                                <div ref={gridRef} className='bookinggrid' ></div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default OrdersViewDetails;